<template>
  <div class="visualReport-container">
    <div class="dydl-wd">
      <div class="wd-container" :class="{ 'is-google-map': mapchange === '2' }">
        <div class="map-radio">
              <span>{{$t('operate.name72')}}</span>
              <el-radio v-model="mapchange" label="1" @change="mapchangeradio">{{$t('operate.name74')}}</el-radio>
              <el-radio v-model="mapchange" label="2" @change="mapchangeradio">{{$t('operate.name73')}}</el-radio>
        </div>
        <div class="baidu-map" v-show="mapchange === '1'">
          <!-- <div class="query-form"> -->
          <!-- <div class="gjsd">{{$t('operate.name75')}}<el-slider v-model="speedbaidu" style="width: 200px" :step="1" :min="10"></el-slider></div> -->
          <!-- <div>
            <el-button type="primary" @click="handleQuery">{{$t('operate.name77')}}</el-button>
            <el-button type="primary" @click="handPathStop">{{$t('operate.name78')}}</el-button>
          </div> -->
          <!-- </div> -->
           <div id="faultMapDiv" class="map" ></div>
        <!-- <baidu-map class="map" :center="markerPointbaidu" :zoom="20" :scroll-wheel-zoom='true' @ready="handleMap"> -->
              <!-- <bm-polyline :path="pathbaidu" stroke-color="#275aff" :stroke-opacity="0.8" :stroke-weight="5"
                           :editing="false"
              ></bm-polyline> -->
              <!-- <bm-marker :position="startmarkerPointbaidu" :icon="startmarkericonbaidu"></bm-marker> -->
              <!-- <bm-marker :position="markerPointbaidu" :icon="pointsmarkericon1"></bm-marker> -->
              <!-- <bml-lushu
                @stop="reset"
                :speed="speedbaidu*5"
                :path="pathbaidu"
                :icon="pointsmarkericon1"
                :play="playbaidu">
              </bml-lushu> -->
            <!-- </baidu-map> -->
            <div class="address">
              {{ address }}
            </div>
        </div>
        <div class="gooles-map" v-if="mapchange === '2'">
          <GmapMap :center='markerPoint' :zoom='18' ref="mapRef" class="map" id="faultGoogleMap">
            <gmap-marker
              :position="markerPoint"
              :icon="pointsmarkericon1">
            </gmap-marker>
          </GmapMap>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import { buildRecentHoursShortcuts, buildDisabledFutureDate } from '@/utils/datePickerShortcuts.js'
import { parseFaultLngLat } from '@/utils/faultMapCoords.js'
import { defaultMapChangeReport } from '@/config/flavor'
// import { BmlLushu } from 'vue-baidu-map'
export default {
  props: {
    itemdata: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(['userinfo']),
    google: gmapApi,
    pickerOptions () {
      return {
        shortcuts: buildRecentHoursShortcuts(this),
        disabledDate: buildDisabledFutureDate(this)
      }
    }
  },
  components: {
    // BmlLushu
  },
  data() {
    return {
      topData: {},
      loading: false,
      dialogVisible: false,
      caution: require('@/assets/caution.png'),
      lineChart1: null,
      lineChart2: null,
      blData: [],
      blLabel: '',
      typeOptions: [],
      // 缺省来自 flavor：国内 tdt('1') / 海外 google('2')；用户仍可切换
      mapchange: defaultMapChangeReport,
      car_animate: null,
      count: 0,
      count2: 0,
      markerPoint: {
        lng: 0,
        lat: 0
      },
      icon: {
        url: require('@/assets/bike.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      startmarkericon: {
        url: require('@/assets/start.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      endmarkericon: {
        url: require('@/assets/end.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      bikemarkericon: {
        url: require('@/assets/bike.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      startmarkerPoint: {
        lng: 0,
        lat: 0
      },
      endmarkerPoint: {
        lng: 0,
        lat: 0
      },
      startmarkericonbaidu: {
        url: require('@/assets/start.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      endmarkericonbaidu: {
        url: require('@/assets/end.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      pointsmarkericon: {
        url: require('@/assets/caution.png'),
        size: {
          width: 16,
          height: 16
        },
        opts: {
          imageSize: {
            width: 16,
            height: 16
          }
        }
      },
      pointsmarkericon1: {
        url: require('@/assets/caution.png'),
        size: {
          width: 32,
          height: 32
        },
        // caution 针尖在图标底部中点；锚点对准经纬度，避免与天地图目视偏移
        scaledSize: {
          width: 32,
          height: 32
        },
        anchor: {
          x: 16,
          y: 32
        }
      },
      markerPointbaidu: {
        lng: 0,
        lat: 0
      },
      startmarkerPointbaidu: {
        lng: 0,
        lat: 0
      },
      endmarkerPointbaidu: {
        lng: 0,
        lat: 0
      },
      BMap: null,
      map: null,
      pointsMarker: [],
      path: [],
      bikePath: [],
      speed: 0,
      speedbaidu: 30,
      pathbaidu: [],
      playbaidu: true,
      clickIndex: -1,
      queryInfo: {
        searchTime: [],
        ebikeId: ''
      },
      tableList: [],
      xWDData: [],
      yWDData1: [],
      yWDData2: [],
      yWDData3: [],
      xDLDYData: [],
      yDLDYData1: [],
      yDLDYData2: [],
      xSDGLData: [],
      ySDGLData1: [],
      ySDGLData2: [],
      xBLData: [],
      yBLData: [],
      bLLegend: [],
      address: '',
      mapTD: null,
      dataTime: '',
      pickerMinDate: '',
      maxDate: null,
      minDate: null
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      // 按缺省底图分支：'1'=天地图 走 initMap；'2'=谷歌 走 refreshGoogleMap（设坐标+resize）
      if (this.mapchange === '2') {
        this.refreshGoogleMap()
      } else {
        this.initMap()
      }
    })
  },
  beforeDestroy() {
    this.destroyMap()
  },
  watch: {
    itemdata: {
      handler(val) {
        if (val && val.faultAddr) {
          this.$nextTick(() => {
            if (this.mapchange === '2') {
              this.refreshGoogleMap()
            } else {
              this.initMap()
            }
          })
        }
      },
      deep: true
    }
  },
  methods: {
    refreshMap() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.mapchange === '1') {
            if (!this.initMap()) {
              setTimeout(() => this.initMap(), 200)
            }
          } else {
            this.refreshGoogleMap()
          }
        }, 100)
      })
    },
    destroyMap() {
      const container = document.getElementById('faultMapDiv')
      if (container) {
        container.innerHTML = ''
      }
      this.mapTD = null
    },
    reset () {
      this.playbaidu = false
    },
    handleMap({ BMap, map }) {
      this.map = map
      this.BMap = BMap
      map.disableDragging()
      this.getlngLatAlt()
    },
    initMap() {
      if (!this.itemdata || !this.itemdata.faultAddr) {
        return false
      }
      const container = document.getElementById('faultMapDiv')
      if (!container || container.offsetWidth === 0) {
        return false
      }
      this.destroyMap()
      this.getlngLatAlt()
      return true
    },
    getlngLatAlt() {
      const that = this
      this.path = []
      this.pathbaidu = []
      this.tableList = []
      this.bikePath = []
      this.pointsMarker = []
      this.startmarkerPointbaidu = { lng: 0, lat: 0 }
      this.endmarkerPointbaidu = { lng: 0, lat: 0 }
      const parsed = parseFaultLngLat(this.itemdata.faultAddr, 'tianditu')
      if (!parsed) return
      this.pathbaidu.push({ lng: parsed.lng, lat: parsed.lat })
      if (this.pathbaidu) {
        this.markerPointbaidu.lng = this.pathbaidu[0].lng
        this.markerPointbaidu.lat = this.pathbaidu[0].lat
        that.T = window.T // 这个一定需要定义，可以直接在mounted里面定义
        let mapTD = null
        mapTD = new that.T.Map('faultMapDiv', {
          attributionControl: true,
          inertia: true
        })
        that.mapTD = mapTD
        mapTD.centerAndZoom(new that.T.LngLat(this.markerPointbaidu.lng, this.markerPointbaidu.lat), 18)
        const control = new that.T.Control.Zoom()
        mapTD.addControl(control)
        var marker = new that.T.Marker(new that.T.LngLat(that.markerPointbaidu.lng, that.markerPointbaidu.lat), {
          icon: new that.T.Icon({
            iconUrl: that.caution,
            iconSize: new that.T.Point(32, 32),
            iconAnchor: new that.T.Point(16, 32)
          })
        })
        mapTD.addOverLay(marker)
        if (typeof mapTD.checkResize === 'function') {
          mapTD.checkResize()
        }
        var geocode = new that.T.Geocoder()
        // var lnglat = { lat: parseFloat(this.markerPointbaidu.lat), lng: parseFloat(this.markerPointbaidu.lng) }
        // console.log('====', lnglat)
        const point = new that.T.LngLat(this.markerPointbaidu.lng, this.markerPointbaidu.lat)
        geocode.getLocation(point, function (result) {
          console.log('====', result)
          if (result.status === '0') {
            that.address = result.formatted_address
          }
        })

        // const geoc = new this.BMap.Geocoder()
        // const pt = new this.BMap.Point(this.markerPointbaidu.lng, this.markerPointbaidu.lat)
        // geoc.getLocation(pt, (rs) => {
        //   console.log('rs==', rs)
        //   if (rs.surroundingPois.length) {
        //     this.address = rs.surroundingPois[0].address
        //   } else {
        //     this.address = rs.address
        //   }
        // })
      }
    },
    handPathStop () {
      this.playbaidu = false
    },
    bikePolyLine () {
      var lineSymbol = {
        path: this.google.maps.SymbolPath.FORWARD_OPEN_ARROW,
        fillColor: '#FFF',
        strokeColor: '#FFF',
        scale: 0.9,
        strokeWeight: 3,
        fillOpacity: 0.8
      }
      this.stratbikemaker()
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.flightPath = new this.google.maps.Polyline({
          path: this.path,
          strokeColor: '#275aff',
          icons: [{
            icon: lineSymbol,
            offset: '0',
            repeat: '5%'
          }],
          strokeOpacity: 0.8,
          strokeWeight: 10
        })
        this.flightPath.setMap(map)
      })
    },
    bikePolyLinestart () {
      clearInterval(this.car_animate)
      this.car_animate = setInterval(() => {
        this.markerBlack.setIcon(this.pointsmarkericon)
        this.markerBlack.setPosition(this.path[this.count])
        this.count += 1
        this.count2 = this.count
        if (this.count === this.path.length) {
          this.markerBlack.setPosition(this.path[this.path.length - 1])
          this.count2 = 0
          this.count = 0
          clearInterval(this.car_animate)
        }
      }, (1 / this.speed) * 7000)
    },
    inputspeed (speed) {
      this.speed = speed
    },
    applyGoogleFaultCoords () {
      if (!this.itemdata || !this.itemdata.faultAddr) return false
      // 国内谷歌瓦片为 GCJ-02，海外保持 WGS84（与骑行轨迹一致）
      const parsed = parseFaultLngLat(this.itemdata.faultAddr, 'google')
      if (!parsed) return false
      this.markerPoint = { lng: parsed.lng, lat: parsed.lat }
      this.startmarkerPoint = { lng: parsed.lng, lat: parsed.lat }
      this.endmarkerPoint = { lng: parsed.lng, lat: parsed.lat }
      this.path = [{ lng: parsed.lng, lat: parsed.lat }]
      return true
    },
    refreshGoogleMap () {
      if (this.mapchange !== '2') return
      if (!this.applyGoogleFaultCoords()) return
      this.$nextTick(() => {
        setTimeout(() => {
          if (!this.$refs.mapRef) return
          this.$refs.mapRef.$mapPromise.then((map) => {
            if (this.google && this.google.maps) {
              this.google.maps.event.trigger(map, 'resize')
              map.setCenter(this.markerPoint)
              map.setZoom(18)
            }
          }).catch(() => {})
        }, 200)
      })
    },
    mapchangeradio() {
      if (this.mapchange === '1') {
        this.initMap()
      } else {
        this.refreshGoogleMap()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.visualReport-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  .top-ds{
    width: calc(100% - 30px);
    display: flex;
    justify-content: space-between;
    height: 100px;
    border: 1px solid #f1f1f1;
    margin-bottom: 20px;
    padding: 0px 15px;
    .item{
      width: 100%;
      display: flex;
      flex-direction: column;
      height: 100px;
      justify-content: center;
      .label{
        font-size: 18px;
        font-weight: 700;
      }
      .value{
        font-family: 'D-DIN-PRO-700';
        font-size: 18px;
      }
      .margin-top10{
        margin-top: 10px;
      }
    }
  }
  .margin-top20{
    margin-top: 20px;
  }

  .map-radio{
    display: flex;
    z-index: 999;
    position: absolute;
    left: 50px;
    top: 15px;
    align-items: center;
    background: rgba(255, 255, 255, 0.92);
    padding: 4px 8px;
    border-radius: 4px;
  }

  .wd-container.is-google-map {
    .map-radio {
      left: auto;
      right: 56px;
      top: 10px;
    }
  }

  .writing-mode{
    writing-mode: vertical-rl;
    }

  .dydl-wd {
    width: 100%;
    display: flex;
    flex-direction: row;
    .dydl-container{
      position: relative;
      width:50%;
      display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: center;
     border: 1px solid #f1f1f1;
     padding: 10px;
    }
    .dydl {
      width:100%;
      height: 400px;
    }
    .bll-select{
      width: 180px;
      margin-left: 20px;
      position: absolute;
      left: 0;
      top: 10px;
      display: flex;
      z-index: 999;
      justify-content: space-between;
      align-items: center;
    }

    .wd-text{
      display: flex;
      flex-direction: column;
      align-items: center;
      font-weight: 600;
     }

    .dcdy{
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #42bf7c;
      font-weight: 600;
     }

     .dcdl{
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #5a7ff1;
      font-weight: 600;
     }
     .gz-table{
      width: 100%;
      display: flex;
      flex-direction: column;
      height: 400px;
      padding: 10px;
      .title{
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 20px;
      }
      .row1{
        width: 30%;
        padding-left: 10px;
      }
      .row2{
        width: 20%;
      }
      .row3{
        width: 30%;
      }
      .row4{
        width: 20%;
      }
      .icon{
        width: 25px;
        height: 25px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .table-title{
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 600;
        padding: 10px 0px;
        border-bottom: 1px solid #f1f1f1;
      }
      .table-content{
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        height: 360px;
        overflow: auto;
        margin-top: 10px;
      }
      .nodata{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .item-content-active{
        background: #f1f1f1;
      }
      .item-content{
        width: 100%;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        padding: 10px 0px;
        align-items: center;
      }
     }

     .margin-left15{
      margin-left: 15px;
     }

     .wd-container{
      position: relative;
      width: 100%;
      display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: center;
     padding-right: 10px;
    .wd {
      width: 100%;
      height: 400px;
    }
  }
  }
  .baidu-map{
    width: 100%;
    position: relative;
  }
  .address{
    z-index: 9999;
    position: absolute;
    bottom: 0;
    right: 0;
    left: auto;
    max-width: calc(100% - 20px);
    font-weight: 800;
    text-align: right;
    word-break: break-word;
    line-height: 1.4;
  }
  .gooles-map{
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .map{
    width: 100%;
    height: 380px;
    min-height: 380px;
  }
  .el-icon-rank{
    font-size: 24px;
    color: black;
    position: absolute;
    bottom: 15px;
    right: 15px;
    z-index: 999;
    cursor: pointer;
  }
  .full-map{
    .map{
      width: 100%;
      height: 800px;
    }
    .query-form{
      display: flex;
    flex-direction: column;
    z-index: 999;
    position: absolute;
    top: 80px;
    left: 20px;
    .gjsd{
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    }
  }
  .query-form{
    display: flex;
    flex-direction: column;
    z-index: 999;
    position: absolute;
    top: 20px;
    left: 20px;
    .gjsd{
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
  .input {
    width: px2vw(147);
  }
  .form-item2 {
    margin-left: px2vw(-15);
  }
  .bt-layout {
    display: flex;
    flex-direction: row;
    height: 36px;
  }
}
</style>
